import type { RootState } from '@reducers/index';
import { updateAdType } from '@reducers/search';
import { useViewport } from '@sbt-web/hooks';
import { AdTypes, FilterURI } from '@sbt-web/network/types';
import {
  FormGroup,
  FormLabel,
  SelectBox,
  SelectOption,
  SelectOptionOptionType,
} from '@sbt-web/ui';
import { adTypesLabelsMap } from '@shared/tools/search/values';
import React from 'react';
import { connect } from 'react-redux';

interface ATStateProps {
  currentAdType: AdTypes;
}

interface ATDispatchProps {
  updateAdType: (adType: AdTypes) => void;
}

interface ATOwnProps {
  adTypes: AdTypes[];
  trackSearchConversion: () => void;
}

type ATProps = ATOwnProps & ATStateProps & ATDispatchProps;

const adTypesMap = new Map<string, SelectOptionOptionType>([
  [
    AdTypes.Sell,
    {
      name: adTypesLabelsMap[AdTypes.Sell],
      value: AdTypes.Sell,
    },
  ],
  [
    AdTypes.Seek,
    {
      name: adTypesLabelsMap[AdTypes.Seek],
      value: AdTypes.Seek,
    },
  ],
  [
    AdTypes.Rent,
    {
      name: adTypesLabelsMap[AdTypes.Rent],
      value: AdTypes.Rent,
    },
  ],
  [
    AdTypes.VacationRent,
    {
      name: adTypesLabelsMap[AdTypes.VacationRent],
      value: AdTypes.VacationRent,
    },
  ],
  [
    AdTypes.GiveAway,
    {
      name: adTypesLabelsMap[AdTypes.GiveAway],
      value: AdTypes.GiveAway,
    },
  ],
]);

export const AdTypeComponent: React.FunctionComponent<ATProps> = ({
  currentAdType,
  adTypes,
  updateAdType,
  trackSearchConversion,
}) => {
  const { isMobile } = useViewport();

  const valueListFromAdTypes = adTypes.map((adType) => adTypesMap.get(adType));

  const handleSelection = (options: SelectOption[]) => {
    trackSearchConversion();
    return updateAdType(options[0].value as AdTypes);
  };

  const index = adTypes.findIndex((t) => t === currentAdType);

  if (adTypes.length <= 1) return null; // Don't render if we have only one AdType

  return (
    <FormGroup>
      <FormLabel>Tipo di annuncio</FormLabel>
      <SelectBox
        name={FilterURI.AdType}
        type="radio"
        selectedIndices={[index]}
        expanded
        flavor={isMobile ? 'large' : 'small'}
        valueList={valueListFromAdTypes as SelectOptionOptionType[]}
        onSelect={handleSelection}
      />
    </FormGroup>
  );
};

export const AdTypeSelector = connect<
  ATStateProps,
  ATDispatchProps,
  ATOwnProps,
  RootState
>(
  (state: RootState, ownProps: ATOwnProps) => ({
    currentAdType: state.search.adType,
    trackSearchConversion: ownProps.trackSearchConversion,
  }),
  (dispatch) => ({
    updateAdType: (adType: AdTypes) => dispatch(updateAdType(adType)),
  })
)(AdTypeComponent);
